import { useState } from "react";
import { Link, useLocation } from "wouter";
import { useAuth } from "../context/AuthContext.jsx";

function useQueryToken() {
  if (typeof window === "undefined") return "";
  return new URLSearchParams(window.location.search).get("token") || "";
}

export default function ResetPassword() {
  const { resetPassword, error } = useAuth();
  const token = useQueryToken();
  const [, navigate] = useLocation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [mismatch, setMismatch] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMismatch(true);
      return;
    }
    setMismatch(false);
    setSubmitting(true);
    const res = await resetPassword(token, password);
    setSubmitting(false);
    if (res) setDone(true);
  }

  if (!token) {
    return (
      <div className="page" style={{ maxWidth: 400, paddingTop: "18vh" }}>
        <div className="kicker" style={{ marginBottom: 28 }}>
          <span className="the-line" />
          CONQUEST
        </div>
        <h1 style={{ marginBottom: 16 }}>Reset your password</h1>
        <p style={{ color: "var(--muted)" }}>
          This reset link is missing its token. Request a new one from the{" "}
          <Link href="/forgot-password">forgot password</Link> page.
        </p>
      </div>
    );
  }

  return (
    <div className="page" style={{ maxWidth: 400, paddingTop: "18vh" }}>
      <div className="kicker" style={{ marginBottom: 28 }}>
        <span className="the-line" />
        CONQUEST
      </div>
      <h1 style={{ marginBottom: 32 }}>Set a new password</h1>
      {done ? (
        <>
          <p style={{ color: "var(--muted)", marginBottom: 24 }}>
            Your password has been updated. You can now sign in.
          </p>
          <button className="btn-primary" type="button" onClick={() => navigate("/login")}>
            Go to sign in
          </button>
        </>
      ) : (
        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input
            type="password"
            placeholder="New password (min. 8 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            minLength={8}
            required
          />
          {mismatch && (
            <div style={{ color: "var(--error)", fontSize: 13.5 }}>Passwords do not match.</div>
          )}
          {error && <div style={{ color: "var(--error)", fontSize: 13.5 }}>{error}</div>}
          <button className="btn-primary" type="submit" disabled={submitting} style={{ marginTop: 8 }}>
            {submitting ? "Updating…" : "Update password"}
          </button>
        </form>
      )}
      <div style={{ marginTop: 20, fontSize: 13.5 }}>
        <Link href="/login">Back to sign in</Link>
      </div>
    </div>
  );
}
